/****************************************
	Slider
*****************************************/
($ => {
	if ($.slider) {
		ui.warn('ERROR: You are including slider.js multiple times');
		return;
	}
	const slider = {
		create($element) {
			let instance = $element.data('sliderInstance');
			if (instance) {
				instance.destroy();
			}
			instance = Object.create(this.proto);
			instance.$element = $element;
			instance.uniqueId = $element.attr('id') || `modal-${ui.getRandomNumber()}`;
			instance.$label = $element.next('label');
			instance.$handle = instance.$label.find('.sliderHandle');
			instance.$button = instance.$handle.find('span');
			instance.leftSpacing = 32;
			instance.rightSpacing = -24;
			instance._init();
			$element.data('sliderInstance', instance);
			return instance;
		},
		proto: {
			_clear() {
				this.$handle
					.removeClass('sliding slidingToOn slidingToOff')
					.off('.slider');
				$(document).off(`.slider.${this.uniqueId}`);
				this.$button.css('left', '');
				delete this.pageX;
				delete this.position;
				delete this.leftBound;
				delete this.rightBound;
			},
			destroy() {
				this._clear();
				this.$element.add(this.$label).add(this.$button).off('.slider');
				this.$element.removeData('sliderInstance');
			},
			_init() {
				this.$button.on('mousedown.slider touchstart.slider', e => this._start(e));
			},
			_start(e) {
				this.pageX = {
					initial: e.originalEvent && e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX
				};
				this.position = {
					initial: parseInt(this.$button.css('left'), 10)
				};
				this.leftBound = this.leftSpacing;
				this.rightBound = parseInt(this.$handle.css('width'), 10) - parseInt(this.$button.css('width'), 10) - this.rightSpacing;
				this.$handle
					.addClass('sliding')
					.on('mousemove.slider touchmove.slider', evt => this._update(evt));
				$(document).on(`mouseup.slider.${this.uniqueId} touchend.slider.${this.uniqueId}`, () => this._stop());
				return false;
			},
			_stop() {
				let checked = this.$element.prop('checked');
				if (isNaN(this.position.final) || (Math.abs(this.position.initial - this.position.final) / (this.rightBound - this.leftBound) > 0.3)) {
					checked = !checked;
				}
				this._clear();
				setTimeout(() => {
					this.$element.prop('checked', checked); /* The DOM will not update this property without this setTimeout. */
				});
				return false;
			},
			_update(e) {
				let scale = 0;
				const fromLeft = this.position.initial < this.leftBound + 1 && this.position.initial > this.leftBound - 1;
				const fromRight = this.position.initial < this.rightBound + 1 && this.position.initial > this.rightBound - 1;
				this.pageX.final = e.originalEvent && e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
				/* Set limits on position.final to leftBound and rightBound. */
				this.position.final = Math.min(Math.max(this.position.initial + (this.pageX.final - this.pageX.initial), this.leftBound), this.rightBound);
				scale = (this.position.final - this.leftBound) / (this.rightBound - this.leftBound);
				if ((fromLeft && scale > 0.3) || (fromRight && scale > 0.7)) {
					this.$handle.addClass('slidingToOn').removeClass('slidingToOff');
				} else {
					this.$handle.addClass('slidingToOff').removeClass('slidingToOn');
				}
				this.$button.css('left', this.position.final);
				return false;
			}
		}
	};
	$.fn.slider = function init(options, ...args) {
		/* If options is a string, we assume it refers to a method. */
		const isMethodCall = typeof options === 'string';
		let returnValue = this;
		this.each((i, el) => {
			const $el = $(el);
			if (isMethodCall) {
				const instance = $el.data('sliderInstance');
				if (!instance) {
					ui.warn(`Cannot call methods on slider prior to initialization; attempted to call method "${options}".`);
					return false;
				}
				if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
					ui.warn(`No such method "${options}" for slider.`);
					return false;
				}
				const methodValue = instance[options](...args);
				if (methodValue !== instance && methodValue !== undefined) {
					returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
					return false;
				}
			} else {
				slider.create($el);
			}
		});
		return returnValue;
	};
	$.slider = {
		getTest() {
			return Object.assign({}, slider);
		}
	};
	/* Auto instantiating only those not explicitly excluded */
	$(() => $('.slider:not([data-auto-instantiate="off"])').slider());
})(jQuery);
